import { getApiRequest } from 'api';
import { AdaptationStudent } from 'types/students';

export const getAdaptationProgress = (): Promise<AdaptationStudent[]> => getApiRequest(`/adaptation-progress/`);
